var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7739_17866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.302L11.912 18.0946L12.3966 17.5676V12.3481L16.8839 9.89481V21.1323L12.0052 24L1.5 17.8235V12.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6435 9.03801L17.6038 20.7081L22.4862 17.8367L22.4862 6.1242L17.5796 3.25666L7.47433 9.13347L12.0229 11.6532L17.0765 8.86497L17.6435 9.03801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47561 8.86289L16.8561 2.83387L12.0052 0L1.5 6.14492V11.4175L11.6079 16.9828V12.3785L6.66647 9.5565L6.47561 8.86289Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7739_17866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsv);
export default __webpack_public_path__ + "static/media/bsv.ba9ca7293ddd56c2d3c99e4ffee831f1.svg";
export { ForwardRef as ReactComponent };